import { Outlet, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import useRefreshToken from './useRefreshToken'
import useAuth from './useAuth'
import { Progress } from '../components/ui/progress'
import { useToast } from '../components/ui/use-toast'

// const PersistLogin = () => {
//   const [isLoading, setIsLoading] = useState(true)
//   const refresh = useRefreshToken()
//   const { auth } = useAuth()
//   const navigate = useNavigate()
//   const [progress, setProgress] = useState(10)
//   const { toast } = useToast()

//   useEffect(() => {
//     let isMounted = true

//     const verifyRefreshToken = async () => {
//       try {
//         await refresh()
//       } catch (err) {
//         console.error('Refresh failed:', err)

//         toast({
//           variant: 'destructive',
//           title: 'Session expired',
//           description: err?.response?.data?.message || 'Please login again'
//         })

//         navigate('/', { replace: true })
//       } finally {
//         isMounted && setIsLoading(false)
//       }
//     }

//     // If no accessToken but we have refreshToken → try refresh
//     if (!auth?.accessToken && auth?.refreshToken) {
//       verifyRefreshToken()
//     } else {
//       setIsLoading(false)
//     }

//     return () => {
//       isMounted = false
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   useEffect(() => {
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isLoading])
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setProgress(prev => prev + 5)
//       if (progress === 100) setProgress(10)
//     }, 1000)
//     return () => clearInterval(interval)
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   return (
//     <>
//       {isLoading ? (
//         <div className='w-full h-[80vh] flex justify-center items-center flex-col gap-[20px]'>
//           {' '}
//           <img srcSet='/sproxillogo.png' alt='' style={{ width: '110px' }} />
//           <Progress value={progress} className='w-[30%]' />
//         </div>
//       ) : (
//         <Outlet />
//       )}
//     </>
//   )
// }

// export default PersistLogin



const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true)
  const refresh = useRefreshToken()
  const { auth } = useAuth()
  const navigate = useNavigate()
  const [progress, setProgress] = useState(10)
  const { toast } = useToast()

  useEffect(() => {
    let isMounted = true

    const verifyRefreshToken = async () => {
      try {
        await refresh()
      } catch (err) {
        console.error('Refresh failed:', err)

        toast({
          variant: 'destructive',
          title: 'Session expired',
          description: err?.response?.data?.message || 'Please login again'
        })

        navigate('/', { replace: true })
      } finally {
        isMounted && setIsLoading(false)
      }
    }

    // CASE 1: We have access token → allow immediately
    if (auth?.accessToken) {
      setIsLoading(false)
      return
    }

    // CASE 2: No access token but refresh token exists → try refresh
    if (!auth?.accessToken && auth?.refreshToken) {
      verifyRefreshToken()
      return
    }

    // CASE 3: No tokens at all → force login
    if (!auth?.accessToken && !auth?.refreshToken) {
      navigate('/', { replace: true })
      return
    }

    return () => {
      isMounted = false
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => (prev >= 100 ? 10 : prev + 5))
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <>
      {isLoading ? (
        <div className='w-full h-[80vh] flex justify-center items-center flex-col gap-[20px]'>
          <img srcSet='/sproxillogo.png' alt='' style={{ width: '110px' }} />
          <Progress value={progress} className='w-[30%]' />
        </div>
      ) : (
        <Outlet />
      )}
    </>
  )
}

export default PersistLogin
